import { useEffect } from 'react';

import {
  useAllJobProspectsActions
} from './AllJobProspectsContext';

import {
  getAllJobProspects,
} from './restApi';

const AllJobProspectsLoader = () => {
  const { initializeState, onResponse, onError } = useAllJobProspectsActions();

  useEffect(() => {
    initializeState();
  }, []);

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    getAllJobProspects({
      onResponse,
      onError,
      body: {
        authenticityToken,
      },
    });
  }, []);

  return null;
};

export default AllJobProspectsLoader;
